import {audioApi} from '../shared/audio-api'
import {backdrop} from '../shared/backdrop'
import {useSharedStore} from '../state/shared-store-context'
import {effect} from '../shared/effect'

export function useGlobalActions() {
    const {actions} = useSharedStore()

    effect([actions], () => {
        audioApi.enableAutoplayAction = actions.enableAutoplay
        backdrop.registerActions(actions)
        return () => { audioApi.enableAutoplayAction = null }
    })
}
